<div class="not-found">
  <a class="not-found-logo" [href]="backUrl" aria-label="0account console">
    <img src="assets/images/icons/0account-logo.svg" alt="0account" />
  </a>
  <div class="not-found-card">
    <nz-result nzStatus="404" nzTitle="Page not found" nzSubTitle="Sorry, the page you visited does not exist.">
      <div nz-result-extra>
        <a nz-button nzType="primary" nzSize="large" [href]="backUrl">Back to the main page</a>
      </div>
    </nz-result>
  </div>
</div>
